var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68754 4.91797C5.28285 4.91797 3.33337 6.86745 3.33337 9.27214V22.7305C3.33337 25.1352 5.28285 27.0846 7.68754 27.0846H24.3125C26.7172 27.0846 28.6667 25.1352 28.6667 22.7305V14.0221C28.6667 11.6174 26.7172 9.66797 24.3125 9.66797H9.27087C8.6128 9.66797 8.08337 10.1974 8.08337 10.8555C8.08337 11.5135 8.6128 12.043 9.27087 12.043H24.3125C25.406 12.043 26.2917 12.9286 26.2917 14.0221V22.7305C26.2917 23.824 25.406 24.7096 24.3125 24.7096H7.68754C6.59405 24.7096 5.70837 23.824 5.70837 22.7305V9.27214C5.70837 8.17865 6.59405 7.29297 7.68754 7.29297H25.8959C26.5539 7.29297 27.0834 6.76354 27.0834 6.10547C27.0834 5.4474 26.5539 4.91797 25.8959 4.91797H7.68754ZM22.3334 19.9596C22.7533 19.9596 23.156 19.7928 23.453 19.4959C23.7499 19.199 23.9167 18.7962 23.9167 18.3763C23.9167 17.9564 23.7499 17.5536 23.453 17.2567C23.156 16.9598 22.7533 16.793 22.3334 16.793C21.9134 16.793 21.5107 16.9598 21.2138 17.2567C20.9169 17.5536 20.75 17.9564 20.75 18.3763C20.75 18.7962 20.9169 19.199 21.2138 19.4959C21.5107 19.7928 21.9134 19.9596 22.3334 19.9596Z",
    fill: "#526077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.208ca7ed.svg";
export { ForwardRef as ReactComponent };